import { useQuery } from '@tanstack/react-query'
import { useMemo, useState } from 'react'
import {
  BLOG_ARTICLES_LIST_PARAMS,
  requestNextApiEndpoint,
} from '~/lib/handle-api'

import { ArticleCardProps } from '~/components/Slices/ArticleCard'

import useLocale from '~/hooks/useLocale'

export default function useArticlesList(previewRef?: string) {
  const locale = useLocale()
  const [page, setPage] = useState<number>(1)
  const [categoryIds, setCategoryIds] = useState(null)

  const { data, isLoading, isFetching } = useQuery<
    unknown,
    unknown,
    { articles: ArticleCardProps[]; maxPage: number }
  >(
    ['article_list', { categoryIds, locale, page }],
    async () => {
      if (!categoryIds || !page) {
        return []
      }

      const { data: queryArticles, maxPage } = await requestNextApiEndpoint(
        BLOG_ARTICLES_LIST_PARAMS,
        {
          payload: {
            categoryIds,
            locale,
            page: page?.toString(),
            previewRef,
          },
        },
      )

      return { articles: queryArticles ?? [], maxPage }
    },
    { refetchOnMount: false, keepPreviousData: true },
  )

  const { articles, maxPage } = useMemo(
    () => ({
      articles: data?.articles ?? [],
      maxPage: data?.maxPage ?? null,
    }),
    [data?.articles, data?.maxPage],
  )

  return {
    articles,
    maxPage,
    isLoading,
    isFetching,
    page,
    setPage,
    setCategoryIds,
  }
}
